import { render, staticRenderFns } from "./uplateName.vue?vue&type=template&id=e9b5247a&scoped=true"
import script from "./uplateName.vue?vue&type=script&lang=js"
export * from "./uplateName.vue?vue&type=script&lang=js"
import style0 from "./uplateName.vue?vue&type=style&index=0&id=e9b5247a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b5247a",
  null
  
)

export default component.exports